export const INITIAL_STATE = {
  example: {}
}
